import React, { Suspense } from 'react'
import { Switch, Route, NotFound } from '@fs/zion-router'
import { NoticeLoading } from '@fs/zion-icon'
import ErrorBoundary from '@fs/zion-error-boundary'

// Dynamically load components to reduce bundle size
// https://reactjs.org/docs/react-api.html#reactlazy

const SearchPage = React.lazy(() => import('./components/pages/SearchPage'))

function App() {
  return (
    <ErrorBoundary>
      <Suspense fallback={<NoticeLoading />}>
        <Switch>
          <Route exact path="/help/helpcenter/help-search" component={SearchPage} requirePersonalData />

          {/* blank page for performance testing purposes only */}
          <Route path="/blank" component={() => 'This page is intentionally left blank'} />

          <Route component={NotFound} />
        </Switch>
      </Suspense>
    </ErrorBoundary>
  )
}
export default App
